<div class="ibox-content no-scroll-mode" style="background: transparent; padding: 0;">
    <div class="app-list-wrapper">
        <div class="apps-filter">
            <div class="input-group search-field">
                <div class="search-field-wrapper">
                    <input [(ngModel)]="searchString" type="text" placeholder="Search Instructions"
                           class="input form-control search-field__input" (input)="searchOnInput()"  maxlength="300">
                    <div class="input-group-btn search-field__button">
                        <button *ngIf="searchString" (click)="clearSearch()"
                                class="btn btn btn-default clear-search"><i class="fa fa-times"></i></button>
                        <div *ngIf="!searchString" class="btn btn btn-default bd-left-none"><i class="fa fa-search"></i></div>
                    </div>
                </div>
            </div>

            <div class="display-flex">
                <h4 class="m-r-sm">Category</h4>
                <settings-integrations-category-filter></settings-integrations-category-filter>
            </div>

            <div class="display-flex">
                <h4 class="m-r-sm">Filter</h4>
                <settings-integrations-category-filter></settings-integrations-category-filter>
            </div>
            <span class="close" (click)="goToCorporationsList()">×</span>
        </div>

        <div class="app-list">
            <ul>
                <li *ngFor="let app of settingsIntegrationsService.data.allSettingsAmenities.data" (click)="toggleCheck(app)">
                    <div class="display-flex">
                    <i class="fa fa-check-circle mtv-primary-color"
                       aria-hidden="true"
                       *ngIf="app.id == settingsIntegrationsService.selectedItemData?.id">
                    </i>
                    <div class="app-image">
                        <div class="placeholder"></div>
                    </div>
                    <div>
                        <div class="category-name">Category</div>
                        <div class="app-name">{{app.name}}</div>
                        <div class="display-flex">
                            <div class="app-price">Free</div>
                            <div class="app-rating">
                                <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                                <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                                <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                                <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                                <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-integrations/settings-integrations-apps-list/settings-integrations-apps-list.component.html